export * from './alteracao-cadastral.component';
